import PropTypes from 'prop-types';
import React from 'react';
import Money from '../../../common/money';
import Date from '../../../common/date';
import Modal from '../../../common/Modal';
import TopUp from '../containers/TopUpModalContainer';
import { getTopUpAmount, getLastTopUp } from '../../helpers';
import { fullName } from '../../../common/helpers/users';
import { t } from '../../../../modules/infra/i18n';

const GiftCardModal = (props) => {
  const {
    giftCard,
    closeModal,
    deleteGiftCard,
  } = props;

  const lastTopUp = getLastTopUp(giftCard);

  return (
    <Modal
      display-if={giftCard}
      close={closeModal}
      title={(
        <span>
          {t('register:gift_cards.modal.title')} <code>{giftCard.code}</code>
        </span>
      )}
    >
      <div className="u-pv u-ph++">
        <div className="o-tableize">
          <div className="o-tableize__row" display-if={giftCard.barberId}>
            <div className="o-tableize__cell">
              <span className="c-label c-label--strong u-mr-">{t('register:gift_cards.modal.barber_label')}</span>
            </div>
            <div className="o-tableize__cell">
              {fullName(giftCard.barber)}
            </div>
          </div>
          <div className="o-tableize__row">
            <div className="o-tableize__cell">
              <span className="c-label c-label--strong u-mr-">
                {t('register:gift_cards.modal.date_purchased_label')}
              </span>
            </div>
            <div className="o-tableize__cell dark-mode-white">
              <Date>{giftCard.createdAt}</Date>
            </div>
          </div>
          <div className="o-tableize__cell">
            <span className="c-label c-label--strong u-mr-">
              {t('register:gift_cards.modal.initial_balance_label')}
            </span>
          </div>
          <div className="o-tableize__cell dark-mode-white">
            <Money>{giftCard.initialBalance}</Money>
          </div>
          <div className="o-tableize__row">
            <div className="o-tableize__cell">
              <span className="c-label c-label--strong u-mr-">{t('register:gift_cards.modal.total_top_up_label')}</span>
            </div>
            <div className="o-tableize__cell dark-mode-white">
              <Money>{getTopUpAmount(giftCard)}</Money>
            </div>
          </div>
          <div className="o-tableize__row">
            <div className="o-tableize__cell">
              <span className="c-label c-label--strong u-mr-">
                {t('register:gift_cards.modal.outstanding_balance_label')}
              </span>
            </div>
            <div className="o-tableize__cell dark-mode-white">
              <Money>{giftCard.outstandingBalance}</Money>
            </div>
          </div>
          <div className="o-tableize__row">
            <div className="o-tableize__cell u-pb" />
          </div>
          <div className="o-tableize__row" display-if={!!lastTopUp}>
            <div className="o-tableize__cell">
              <span className="c-label c-label--strong u-mr-">
                {t('register:gift_cards.modal.last_top_up_amount_label')}
              </span>
            </div>
            <div className="o-tableize__cell dark-mode-white">
              <Money>{lastTopUp.amount}</Money>
            </div>
          </div>
          <div className="o-tableize__row" display-if={!!lastTopUp}>
            <div className="o-tableize__cell">
              <span className="c-label c-label--strong u-mr-">
                {t('register:gift_cards.modal.last_top_up_date_label')}
              </span>
            </div>
            <div className="o-tableize__cell dark-mode-white">
              <Date>{lastTopUp.createdAt}</Date>
            </div>
          </div>
          <div className="o-tableize__row">
            <div className="o-tableize__cell">
              <span className="c-label c-label--strong u-mr-">
                {t('register:gift_cards.modal.date_last_used_label')}
              </span>
            </div>
            <div className="o-tableize__cell dark-mode-white">
              <Date>{giftCard.lastUsedAt}</Date>
            </div>
          </div>
          <div className="o-tableize__row" display-if={giftCard.deletedAt}>
            <div className="o-tableize__cell">
              <span className="c-label c-label--strong u-mr-">{t('register:gift_cards.modal.deleted_at_label')}</span>
            </div>
            <div className="o-tableize__cell dark-mode-white">
              <Date>{giftCard.deletedAt}</Date>
            </div>
          </div>
        </div>
        <div className="o-flexbox u-mt+">
          <button
            display-if={!giftCard.deletedAt}
            className="c-btn c-btn--red u-width-120"
            type="button"
            onClick={deleteGiftCard}
          >
            {t('common:buttons.delete')}
          </button>
          <TopUp giftCard={giftCard} />
        </div>
      </div>
    </Modal>
  );
};

GiftCardModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  deleteGiftCard: PropTypes.func.isRequired,
  giftCard: PropTypes.shape({
    code: PropTypes.string,
    createdAt: PropTypes.string,
    initialBalance: PropTypes.number,
    outstandingBalance: PropTypes.number,
    lastUsedAt: PropTypes.string,
    deletedAt: PropTypes.string,
  }),
};
GiftCardModal.defaultProps = {
  giftCard: null,
};

export default GiftCardModal;
